  // ① セクション ID をカート更新リクエストに追加
  document.addEventListener('cart:grouped-sections', (event) => {
    console.log('[debug] cart:grouped-sections triggered');
    if (window.FoxKitSections) {
      console.log('[debug] pushing section:', window.FoxKitSections);
      event.detail.sections.push(window.FoxKitSections);
    } else {
      console.warn('[debug] FoxKitSections is undefined');
    }
  });

  // ② カートに商品を追加 → セクション再取得 → HTML更新
  const productForm = document.querySelector('form[is="product-form"]');

  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(productForm);
      const sectionId = window.FoxKitSections;

      if (!sectionId) {
        console.warn('[debug] セクションIDが取得できませんでした');
        return;
      }

      console.log('[debug] 商品追加処理開始');

      fetch(FoxTheme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then(() => {
          console.log('[debug] 商品追加成功');

          // セクション取得のためイベント発火
          const groupedEvent = new CustomEvent('cart:grouped-sections', {
            detail: { sections: [] },
          });
          document.dispatchEvent(groupedEvent);

          const sectionsToFetch = groupedEvent.detail.sections;
          console.log('[debug] 再取得対象セクション:', sectionsToFetch);

          // セクションHTML再取得
          return fetch(`${FoxTheme.routes.root_url}?sections=${sectionsToFetch.join(',')}`);
        })
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newShipping = doc.querySelector('[data-shipping-message-wrapper]');
          const currentShipping = document.querySelector('[data-shipping-message-wrapper]');

        if (newShipping && currentShipping) {
          // ① 新しい shipping メッセージの子要素をすべてコピー
          currentShipping.innerHTML = ''; // 古い内容を消す
          Array.from(newShipping.childNodes).forEach((node) => {
            currentShipping.appendChild(node.cloneNode(true));
          });
        
          console.log('[debug] updated shipping message using DOM nodes');
        }

        })
        .catch((err) => {
          console.error('[debug] カート追加エラー', err);
        });
    });
  }